import pagesNiv3et4Codes from "@/utils/pages-niv3&4-codes";
import { hasRecette as hasRecetteUtil } from "@/utils/merch";
import SearchPageCodes from "@/utils/page-recherche-codes";

export const productListPushProps = () => ({
  index: {
    type: Number,
    required: false
  },
  productsListMode: {
    type: String,
    required: true
  },
  pushZones: {
    type: Array,
    required: false
  },
  products: {
    type: Array,
    required: false,
    default() {
      return [];
    }
  },
  pushZone: {
    type: Object,
    required: false
  },
  label: {
    type: String,
    required: false
  },
  pagePushZonesGridCodes: {
    type: Object,
    default: null
  },
  showAboLad: {
    type: Boolean,
    required: false,
    default: false
  },
  isPro: {
    type: Boolean,
    required: false,
    default: false
  },
  hasClickAndCollectTraiteur: {
    type: Boolean,
    required: false,
    default: false
  },
  hasClickAndCollectTraiteurNoel: {
    type: Boolean,
    required: false,
    default: false
  },
  isRecherche: {
    type: Boolean,
    required: false,
    default: false
  }
});

export const productListPushEmits = () => ["meaClicked"];

export const useProductListPush = (props, emit) => {
  const pagePushZonesCodes =
    props.label === "DP" ? pagesNiv3et4Codes : SearchPageCodes;

  const isAbonnementLad = computed(() => {
    return (
      props.pushZone &&
      props.pushZone.html_content &&
      props.pushZone.html_content.includes("abonnement_lad")
    );
  });
  const isTraiteurDeFete = computed(() => {
    return (
      props.pushZone &&
      props.pushZone.html_content &&
      props.pushZone.html_content.includes("traiteur_noel")
    );
  });
  const showTraiteurDeFete = computed(() => {
    return (
      isTraiteurDeFete.value &&
      props.hasClickAndCollectTraiteurNoel &&
      !props.isPro
    );
  });
  const isTraiteurPermanent = computed(() => {
    return (
      props.pushZone &&
      props.pushZone.html_content &&
      props.pushZone.html_content.includes("traiteur_permanent")
    );
  });
  const showTraiteurPermanent = computed(() => {
    return (
      isTraiteurPermanent.value &&
      props.hasClickAndCollectTraiteur &&
      !props.isPro
    );
  });
  const isTraiteurPermanentAlt = computed(() => {
    return (
      props.pushZone &&
      props.pushZone.html_content &&
      props.pushZone.html_content.includes("traiteur_permanent_alt")
    );
  });
  const showTraiteurPermanentAlt = computed(() => {
    return (
      isTraiteurPermanentAlt.value &&
      props.hasClickAndCollectTraiteur &&
      !props.isPro
    );
  });
  const hasRecette = computed(() => {
    return hasRecetteUtil(props.pushZone);
  });

  const getNbColumns = () => {
    if (
      props.productsListMode === "Grid" ||
      props.productsListMode === "Mode"
    ) {
      return props.pushZone.nb_cols ? props.pushZone.nb_cols : 1;
    } else {
      return pagePushZonesCodes.value.LIST_COLUMN_NUMBER;
    }
  };
  const getPushProduct = () => {
    return props.pushZone.products[0];
  };
  const meaClicked = () => {
    emit("meaClicked");
  };

  return {
    isAbonnementLad,
    isTraiteurDeFete,
    showTraiteurDeFete,
    isTraiteurPermanent,
    showTraiteurPermanent,
    isTraiteurPermanentAlt,
    showTraiteurPermanentAlt,
    hasRecette,
    getNbColumns,
    getPushProduct,
    meaClicked
  };
};
